module.exports = __webpack_public_path__ + "static/media/DSC_6808_closer_rounded_512.cc071681.jpg";